import useAuth from 'src/hooks/useAuth';

const useIsUserSupplier = () => {
    const { user } = useAuth();
    const isSupplier = user?.isConsultant;
    return isSupplier;
};

export default useIsUserSupplier;
